var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-between mt-3 mb-3 ml-3 mr-3" },
    [
      _c("CustomButton", {
        attrs: { text: "Cancelar", type: "IconButton" },
        on: {
          click: function() {
            return _vm.irParaListagem()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("CustomButton", {
            attrs: { text: "Salvar", type: "OutlinedButton" },
            on: {
              click: function() {
                return _vm.salvar()
              }
            }
          }),
          _vm._v(" "),
          _c("CustomButton", {
            attrs: {
              text: !_vm.ultimaEtapa ? "Próximo" : "Finalizar",
              icon: !_vm.ultimaEtapa ? "el-icon-plus" : ""
            },
            on: {
              click: function() {
                return _vm.ultimaEtapa
                  ? _vm.finalizar()
                  : _vm.irParaProximaEtapa()
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42da4257", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42da4257","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Buttons/ButtonsFinais/ButtonsFinais.vue
// module id = null
// module chunks = 